<template>
  <div class="sender-message-container">
    <v-textarea placeholder="Say something..." rows="1" v-model="msg" @keydown.enter="sendChatToParent"></v-textarea>
    <div class="sender-container">
      <div class="message-counter">{{msg.length}}/200</div>
      <div class="message-sender">
        <v-icon @click="sendChatToParent" size="20" class="icon-sender">fas fa-paper-plane</v-icon>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "login",
  props: {
    sendChat:{
      type: Function,
    }
  },
  data: () => ({
    msg: "",
  }),
  methods: {
    async sendChatToParent() {
      if (this.msg.length > 0) {
        await this.sendChat(this.msg)
      }
      this.msg = "";
    }
  }
};
</script>
<style lang="scss" scoped>

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 8px;
}
.send-container {
  padding-left: 10px;
  padding-right: 10px;
}

.sender-input {
  // padding-right: 5px;
  // padding-left: 10px;
  // padding-top: 10px;
  border-radius: 0px !important;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  min-height: 50px;
}
</style>
<style >
.sender-input > .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  /* padding: 0 12px; */
  min-height: 50px;
}
.sender-message-container {
  color: #ffffff;
  padding: 20px;
  border: 1px solid #f2f2f2;
}
.message-counter {
  /* float: left; */
  text-align: left;
  width: 50%;
  color: #9b9b9b;
  font-size: 11px;
  font-weight: 400;
  align-self: center;
}
.message-sender {
  /* float: right; */
  text-align: right;
  width: 50%;
}
.icon-sender {
  align-items: center !important;
  display: inline-flex !important;
  font-feature-settings: "liga" !important;
  font-size: 24px !important;
  justify-content: center !important;
  letter-spacing: normal !important;
  line-height: 1 !important;
  position: relative !important;
  text-indent: 0 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s !important;
  vertical-align: middle !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;

  background: unset !important;
  color: #009bde !important;
}
.v-icon.v-icon.v-icon--link {
  font-size: 20px !important;
}
.sender-container {
  display: flex;
}
</style>
